/**
 * An event indicating that async data for expand has finished loading.
 * Dispatch to finish loading states for {@link PrizmExpandComponent}.
 */
export const PRIZM_EXPAND_LOADED = 'prizm-expand-loaded';
